import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-tooltip',
  standalone: true,
  imports: [
    NgbTooltip,
  ],
  templateUrl: './tooltip.component.html',
  styleUrl: './tooltip.component.scss'
})
export class TooltipComponent {
  @Input() tooltipText = '';
  @Input() iconClass = 'icon ic-info-circle-16';
  @Input() placement = 'top';
  @Input() widthAuto = false;
  @Input() customContent = false;
  @Input() isDisabled = false;
  @Output() action = new EventEmitter<boolean>();

  onClick(): void {
    this.action.emit(true);
  }
}
